import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AppBreadcrumbsComponent } from './breadcrumbs.component';

@NgModule({
    declarations: [
        AppBreadcrumbsComponent
    ],
    imports: [
        CommonModule,
        RouterModule
    ],
    exports: [
        AppBreadcrumbsComponent
    ]
})
export class AppBreadcrumbsModule {
}
